import '.bq{position:relative;}.ssr-plugin'
import '.y{width:100%;}.ssr-plugin'
import '.go{min-height:200px;}.ssr-plugin'
import '.h{display:flex;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.l{justify-content:center;}.ssr-plugin'
import '.c3{align-items:flex-start;}.ssr-plugin'
import '.f{padding:2rem;}.ssr-plugin'
import '.cz{background:var(--shades-white);}.ssr-plugin'
import '.ad{overflow:hidden;}.ssr-plugin'
import '.a6{position:absolute;}.ssr-plugin'
import '.iy{top:50%;}.ssr-plugin'
import '.iz{right:1rem;}.ssr-plugin'
import '.j0{transform:translateY(-50%);}.ssr-plugin'
import '.j1{width:120px;}.ssr-plugin'
import '.j2{height:120px;}.ssr-plugin'
import '.j3{z-index:0;}.ssr-plugin'
import '.j{align-items:center;}.ssr-plugin'
import '.ht{z-index:1;}.ssr-plugin'
import '.ai{gap:0.5rem;}.ssr-plugin'
import '.j4{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="bq y go h i l c3 f cz ad"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="a6 iy iz j0 j1 j2 j3 h j l"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="bq ht h i c3 ai j4"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--primary-blue)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--primary-blue)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
